import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { isObservable, Observable, of } from 'rxjs';
import { ElenchiService } from 'app/services/elenchi.service';
import { isArray } from 'lodash-es';

interface InputProps extends FormlyFieldProps {
    options_type:string
}

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'multiselect-read' | Type<MultiSelectReadType>;
}
@Component({
  selector: 'input-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `

  <div *ngIf="(labels$ | async) as values ">
    <ng-container *ngFor="let item of values; let i = index">
      <ng-container *ngIf="item?.group || item?.label">
        <p class="font-semibold" *ngIf="i === 0 || item.group !== values[i - 1].group">{{item.group}}</p>
        <p class="mt-0.5">{{item.label}}</p>
      </ng-container>
   </ng-container>
  </div>

  `,
  imports:[NgIf, NgFor, AsyncPipe]
})
export class MultiSelectReadType extends FieldType<FieldTypeConfig<InputProps>> implements OnInit{

  values:any[];
  labels$:Observable<string[]>
  private _elenchiService = inject(ElenchiService)



  ngOnInit(){
    const values = this.formControl.value

    if (isObservable(this.props.options)){
        this.labels$ = this._elenchiService.getLabelsOption(this.field.props.options_type, values)
    }
    else if (isArray(this.props.options)){
        const res = this.props.options.filter((x: any) =>values?.indexOf(x.value)!=-1);
        this.labels$=of(res)
    }
    else{
        return of(values)
    }

}






    getOptionValues(values:string[]): string[]{
        const value = this.formControl.value
        const options = this.props.options as Array<any>
        const result = [];

        if (options){

            if (values instanceof Array){
                for (let index in values){
                    const vv = options.filter((x: any) => String(x.value) == String(values[index]))
                    result.push(vv[0])
                }
            }
            else{
                const vv = options.filter((x: any) => String(x.value) == String(values))
                result.push(vv[0])
            }
            return result

        }
        else{

            return [value]
        }

    }

    getValues(): string[] {

        const value = this.formControl.value
        const options = this.props.options as Array<any>

        if (value instanceof(Array)){
            return this.getOptionValues(value)
        }
        else{
            return this.getOptionValues([value])
        }

        if (options) {
          return options.filter((x: any) => String(x.value) == String(value))[0]?.label
        }
        else {

          return value
        }
      }


}
